import React from "react";
import { createPortal } from "react-dom";

import "../../../assets/scss/pages/helpdesk.scss";
import { Loader } from "../../../components/loaders/loaders";

/**
 * The app's full-screen loader, portalled to <body> so it is appended after
 * (and so shows above) any open modal while an API call runs. When several
 * are mounted at once (a modal's save + the page reload it starts), only the
 * newest shows, so the backdrop never doubles up.
 */
const BusyLoader: React.FC = () =>
  createPortal(
    <div className="helpdeskBusyLoader">
      <Loader />
    </div>,
    document.body
  );

export default BusyLoader;
